export default __webpack_public_path__ + "f3187c7462849ed261a89dc27e7a4733.svg";